import { useParams } from "react-router-dom";
import ModalButton from "../../../../components/common/form/ModalButton";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import React, { FormEvent, useState } from "react";
import { useRemoveLeaderFromTeamMutation, useTeamLeadersQuery } from "../teamsApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import AddLeader from "../modal/AddLeader";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";

const LeaderTab = () => {

    document.title = `Leader`;
    let { teamId } = useParams();
    const [selectedLeaderId, setSelectedLeaderId] = useState("");
    const [deleteLeaderApi, { isLoading: deleteLeaderApiResponse }] = useRemoveLeaderFromTeamMutation();

    const handleDeleteLeaderSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (selectedLeaderId) {
            return deleteLeaderApi({ teamId: teamId, userId: selectedLeaderId });
        }
    }

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "username",
        },
        {
            label: "Action",
            visibility: {
                canColumnShow: hasPermission(["TEAM-U"]),
                showByDefault: hasPermission(["TEAM-U"]),
                hasShowSetting: false,
            },
            accessor: "creationDate",
            canSort: false,
            cell: (props: any) => {
                return <>
                    <div className="ml-4">
                        {hasPermission(["TEAM-U"]) && (
                            <ModalButton
                                triggerButton={
                                    <FaTrash
                                        className={"cursor-pointer text-highlight-0 text-lg hover:text-highlight-7"}
                                        title={"Delete Leader"} />
                                }
                                onOpen={() => {
                                    setSelectedLeaderId(props.row.original.id)
                                }}
                                modal={
                                    <ConfirmationModal
                                        show={true}
                                        setShow={() => {
                                        }}
                                        title={"Delete Leader"}
                                        bodyMessage={`Are you sure you want to remove ${props.row.original.username} from the leader list ?`}
                                        onSubmit={handleDeleteLeaderSubmit}
                                        isLoading={deleteLeaderApiResponse}
                                    />
                                }
                            />)}
                    </div>
                </>
            }
        }

    ]

    return (
        <>

            {hasPermission(["TEAM-U"]) && <div className={"flex justify-end"}>
                <ModalButton
                    triggerButton={
                        <div
                            className="h-7 w-10 text-text-0 rounded-md bg-highlight-0 flex justify-center items-center cursor-pointer  absolute top-0 left-auto">
                            <FaPlus />
                        </div>
                    }
                    onOpen={() => {
                    }}
                    modal={
                        <AddLeader
                            show={true}
                            setShow={() => {
                            }}
                            teamId={teamId}
                        />
                    }
                />
            </div>}

            <div className=''>
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useTeamLeadersQuery
                    }}
                    defaultFilter={{
                        teamId: teamId
                    }}
                    userSettingGroup={"Team Leader"}
                    appendFilterToUrl={false}
                />
            </div>

        </>
    )
}

export default LeaderTab;